module.exports = __webpack_public_path__ + "static/media/arial-unicode-ms.91f4475d.ttf";